import { createContext, useState } from "react";

export type AuthContexType = {
  token: boolean;
  setUserToken: (bol:boolean) => void;
};

export const AuthContext = createContext<AuthContexType | null>(null);

const AuthContexProvider: React.FC<{ children: React.ReactNode, initialData:boolean }> = ({children, initialData }) => {
  const [token, setToken] = useState(initialData);
  const setUserToken = (bol:boolean) => {
    setToken(bol);
  }
  
  return (
    <AuthContext.Provider value={{ token, setUserToken }}>{children}</AuthContext.Provider>
  );
};

export default AuthContexProvider;
